<template>

  <div>

      <loading class="mt-5" v-if="loading"/>

      <div v-else>
        
        <div>
          <!-- <filtro-lista-bookings @filtrar="obtenerBookings" /> -->
          <filtro-lista-bookings />
        </div>


        <!-- <filtro-lista-bookings data=""/> -->

        <new-data-table
          :headers="headers"
          :data="data"
          :acciones="acciones"
          :max="10"
          paginacion
          buscar
          idtabla="lista_bookings_page"
          withSearch
          :seleccionar="obtenerFilaSeleccionada"
        />

      </div>

      <!-- components -->
      <administrar-instructivo-embarque-modal />
      <!-- <filtro-lista-bookings /> -->
      <ver-detalle-booking-modal :id="id_booking" :booking_itinerary_id="booking_itinerary_id" :data="dataInformacionGeneral" />
      <agregar-instructivo-embarque-modal :id="id" />

  </div>
</template>

<script>
  
  import { mapActions, mapState } from "vuex";

  import { getBookingsConfirmadosClienteFiltrados } from "../../../constants/lineas";

  import Loading from '../../../components/common/loading.vue';
  import NewDataTable from '../../../components/common/NewDataTable.vue';
  // import FiltroListaBookings from '../../../components/filtros/serviciosLogisticos/servicioIntegral/FiltroListaBookings.vue';
  
  import VerDetalleBookingModal from '../../../components/modals/serviciosLogisticos/servicioIntegral/ListarBookings/VerDetalleBookingModal.vue';
  import AgregarInstructivoEmbarqueModal from '../../../components/modals/serviciosLogisticos/servicioIntegral/AgregarInstructivoEmbarqueModal.vue';
  import AdministrarInstructivoEmbarqueModal from '../../../components/modals/serviciosLogisticos/servicioIntegral/AdministrarInstructivoEmbarqueModal.vue';
  import FiltroListaBookings from '../../../components/filtros/serviciosLogisticos/servicioIntegral/FiltroListaBookings.vue';

  export default {

    // components: { NewDataTable, FiltroListaBookings, Loading, AdministrarInstructivoEmbarqueModal, VerDetalleBookingModal, AgregarInstructivoEmbarqueModal },
    components: { NewDataTable, Loading, AdministrarInstructivoEmbarqueModal, VerDetalleBookingModal, AgregarInstructivoEmbarqueModal, FiltroListaBookings },

    data() {
      return {
        headers : ["ID","Semana","Cliente","Shipper","Naviera","Nave","Consignatario","POL","POD","Cantidad","Instructivo E.","N° Booking","Acciones"],
        data: [],
        acciones: [],
        dataDetalleBooking: [],
        id: "",
        id_booking : "",
        booking_itinerary_id : "",
        dataInformacionGeneral : "",
        isSendingToBookingView : false,
      }
    },

    computed : {
      ...mapState(['loading']),
      ...mapState("serviciosLogisticos",["dataTableListaBookings"]),
      ...mapState("lineas",["visibleModalInformacionGeneral"])
    },

    methods: {
      // Acciones de Vuex
      ...mapActions(["AccionCambiar"]),
      ...mapActions("serviciosLogisticos",["actionSetDataTableListaBookings","actionSetAbrirAgregarInstructivoModal","actionSetContadoresInstructivos"]),
      ...mapActions("lineas",["actionSetVisibleModalInformacionGeneral","actionFilterDataBookingsConfirmados"]),

      // Función para actualizar url en state
      actualizarURL() {
        let me = this;
        me.AccionCambiar(this.$route.path);
      },

      async obtenerBookings(){
        await this.actionSetDataTableListaBookings();
      },

      async generarBotonesAcciones() {

        this.acciones = [];

        await this.data.map((_, index) => {

            this.acciones.push([
              {
                icon: "fa fa-search text-secondary",
                title: "Ver detalle de booking",
                id: index,
              },
              {
                icon: "fas fa-truck text-secondary",
                title: "Añadir instructivo de embarque",
                id: index,
              },
              // {
              //   icon: "fas fa-arrow-right text-success",
              //   title: "Ir a bookings confirmados",
              //   id: index,
              // }
            ]);
          
        });

      },

      async obtenerFilaSeleccionada({ id, accion }){

        let {data : data_fila, data_complementaria : {booking_itinerary_id, id_booking}} = this.data[id];

        switch (accion) {

          case "Añadir instructivo de embarque" :

              this.id = data_fila[11];
              this.actionSetAbrirAgregarInstructivoModal(true);
              
            break;

          case "Ver detalle de booking" :

              this.dataInformacionGeneral = data_fila;
              this.id_booking             = id_booking;
              this.booking_itinerary_id   = booking_itinerary_id;

            break;

          // case "Ir a bookings confirmados" : 

          //     if (!this.isSendingToBookingView) {
          //       this.isSendingToBookingView = true;
          //       this.$vToastify.loader("Redireccionando a Bookings confirmados");
          //       this.$router.push( "/lineas/booking/bookings_confirmados");

          //       setTimeout(() => {
          //         this.obtenerBookingConfirmados(booking_itinerary_id);
          //       }, 1100);
          //     }

          //   break;
        
          default:
            break;
        }
        
      },

      async obtenerBookingConfirmados(id){

          const filters =  {
            id: id,
            cliente: null,
            nave: "",
            naviera: null,
            pod: null,
            pol: null,
            semana_inicio: null,
            semana_termino: null,
            anio: "",
            comercial: "",
            servicio_integral: "",
            t_servicio_integral: null,
            no_booking: "",
            referencia: ""
          };
    
          const dataFiltrada = await getBookingsConfirmadosClienteFiltrados(filters);

          setTimeout(() => {
            this.actionFilterDataBookingsConfirmados( dataFiltrada ) ;
            this.$vToastify.stopLoader();
          }, 800);
            
          this.isSendingToBookingView = false;

      },

      cargarContadores(){
        this.actionSetContadoresInstructivos();
      }

    },

    mounted(){
      this.cargarContadores();
    },

    created() {
      // Ejecución de actualizarURL una vez que se carga el componente
      this.actualizarURL();
      this.obtenerBookings();
    },

    watch : {

        dataTableListaBookings : function (_new) {

          if (_new) {
            this.data = _new;
            this.generarBotonesAcciones();
          }  

        },

        visibleModalInformacionGeneral : function(){
          this.id_booking = "";
        }

    }

  }
</script>

<style>

</style>